import { Box, Flex, Stack } from "@chakra-ui/react";
import MessageItem from "./MessageItem";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaRobot } from "react-icons/fa";
import ChatRecipientIcon from "../Conversations/ChatRecipientIcon";

export default function Chats({
  messages,
  selectedChatBg,
  chatBg,
  agencyLogoUrl,
}) {
  return (
    <Stack>
      {messages.map((messageItem, index) => (
        <Box key={index}>
          <Flex
            justifyContent={
              messageItem.sentBy === "agent" ||
              messageItem.sentBy === "assistant"
                ? "flex-start"
                : "flex-end"
            }
            alignItems={"center"}
          >
            <Box>
              {messageItem.sentBy === "agent" ? (
                <MdOutlineSupportAgent size={20} />
              ) : messageItem.sentBy === "assistant" ? (
                agencyLogoUrl ? (
                  <ChatRecipientIcon
                    children={
                      <img
                        src={
                          agencyLogoUrl.includes(window.origin)
                            ? agencyLogoUrl
                            : `${window.location.origin}${agencyLogoUrl}`
                        }
                        height={300}
                        width={300}
                        alt="agency_logos"
                      />
                    }
                  />
                ) : (
                  <FaRobot size={20} />
                )
              ) : null}
            </Box>
            <MessageItem
              messageItem={messageItem}
              selectedChatBg={selectedChatBg}
              chatBg={chatBg}
            />
          </Flex>
        </Box>
      ))}
    </Stack>
  );
}
